import { format, startOfToday, formatISO, isSameDay, isTomorrow } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const timeZone = 'Australia/Melbourne';
const timeFormat = new Intl.DateTimeFormat('en-AU', { timeZone, hour: 'numeric', minute: 'numeric' });

/**
 *  When the given date format is in this example
 * format "2022-08-25T00:00:00+10:00", we need to set the
 * Timezone for date formatting to prevent displaying incorrectly
 * @param {*} date
 * @returns
 */
const tzDate = (date) => utcToZonedTime(Date.parse(date), timeZone);

// formatISO - formatting to yyyy-dd-mm:00:00+00:00, consistent with other dates on payload
export const asISOformat = (date) => formatISO(tzDate(date), { representation: 'complete' });

export const asPerformanceDate = (date) => format(Date.parse(date), 'eee d MMM yyyy');

export const asPerformanceDateLong = (date) => format(Date.parse(date), 'EEEE d LLLL yyyy');

export const asTime = (date) => format(Date.parse(date), 'h:mmaaa');

export const asTimeISO = (dateISO) => timeFormat.format(Date.parse(dateISO));

export const isDateToday = (date) => {
  const todaysDate = new Date();
  return isSameDay(todaysDate, date);
};

export const isDateTomorrow = (date) => isTomorrow(date);

export const asYearMonthDay = (date) => format(Date.parse(date), 'yyyy-MM-dd');

export const getDayNameAbbr = (date) => format(tzDate(date), 'ccc');

export const getNumberInMonth = (date) => format(tzDate(date), 'd');

export const calendarMonthYearIdentifier = (date) => format(tzDate(date), 'yyyy-MMMM');

export const getToday = () => asISOformat(startOfToday());

export const asDayMonthYear = (date) => format(date, 'd MMMM, yyyy');
